import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./Logo.css";

import {joinClasses} from "utils";

export default class Logo extends Component
{
	render()
	{
		const classes = joinClasses(
		[
			"logo",
			(this.props.accented && "accent"),
		]);

		return (
			<Link to="/">
				<div onClick={this.props.onClick} className={classes}>
					<div className="base">
						<div className="triangle">
							<div className="empty"></div>
						</div>

						<div className="text">AG</div>
					</div>
				</div>
			</Link>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js